__webpack_require__.b = require("url").pathToFileURL(__filename);

// object to store loaded chunks
// "1" means "loaded", otherwise not loaded yet
var installedChunks = {
	"main": 1
};

// no on chunks loaded

// no chunk install function needed

// no chunk loading

// no external install chunk

// no HMR

// no HMR manifest